import { Component, Input } from '@angular/core';
import { CostOverviewValue } from 'src/app/interfaces/basket';

@Component({
    selector: 'app-basket-payment-costs-overview',
    templateUrl: './basket-payment-costs-overview.component.html',
    styleUrl: './basket-payment-costs-overview.component.scss',
    standalone: false
})
export class BasketPaymentCostsOverviewComponent {
  @Input() basketQuote: CostOverviewValue;
  @Input() basketArticlesSum: number;

  constructor() { }

  get totalCalculation(): number {
    if (!this.basketQuote) return 0;
    return (
      this.basketArticlesSum -
      this.basketQuote.invoice_discount -
      this.basketQuote.payment_discount +
      this.basketQuote.shipment_costs +
      this.basketQuote.surcharges_amount+ 
      this.basketQuote.vat_amount
    );
  }
}